import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, throwError } from 'rxjs';

import { EnumAppMode, ShellType } from 'app/modules/_common/types';

@Injectable({providedIn: 'root'})
export class Common
{
    //
    private static _snackBarMessage: BehaviorSubject<any | null> = new BehaviorSubject(null);
    public static get snackBarMessage$(): Observable<any> {
        return this._snackBarMessage.asObservable();
    }
    public static showSnackBarMessage(message: string, title?: string) {
        this._snackBarMessage.next({ message: message, title: title ? title : 'Close', isError: false });
    }
    public static showSnackBarMessageError(message: string, title?: string) {
        this._snackBarMessage.next({ message: message, title: title ? title : 'Close', isError: true });
    }
    //

    //
    private static _shell_data = {} as ShellType;
    private static _shell: BehaviorSubject<ShellType | null> = new BehaviorSubject(null);
    public static get shell$(): Observable<ShellType> {
        return this._shell.asObservable();
    }
    static shell(field: string, value: string) {
        setTimeout(() => {
            this._shell_data[field] = value;
            this._shell.next(this._shell_data);
        }, 1);
    }
    //

    private static _searchHandler: any;
    public static set_searchHandler(value) {
        Common._searchHandler = value;
    }
    public static searchHandler() {
        return Common._searchHandler;
    }

    public static CatchError(e) {
        //var message = undefined;

        //message = !message && Array.isArray(e.error) && e.error.length > 0 ? e.error[0].phrase || e.error[0].message : message;
        //message = !message && e.constructor === Object ? e.phrase || e.title || e.message : message;
        //message = !message && e.constructor === String ? e : message;
        //message = !message && e.error.constructor === Object ? e.error.phrase || e.error.title || e.error.message : message;
        //message = !message && e.error.constructor === Object ? e.error : message;
        //message = !message && e.error.error.constructor === Object ? e.error.error : message;

        let o = {};

        switch (true) {
            case Array.isArray(e.error) && e.error?.length > 0:
                o = e.error[0];
                break;

            case e.error?.error?.constructor == Object:
                o = e.error.error;
                break;

            case e.error?.constructor == Object:
                o = e.error;
                break;

            case e?.constructor == Object:
                o = e;
                break;

            case e.error?.constructor == String:
                o['message'] = e;
                break;

            case e?.constructor == String:
                o['message'] = e;
                break;

            default:
                o['message'] = 'An error has occured, check console log.';
                break;
        }

        let message = o['phrase'] || o['title'] || o['message'] || o['error'] || o;

        Common.showSnackBarMessageError(message);

        return throwError(() => e);
    }

    public static get appMode(): EnumAppMode {
         switch (true) {
            case sessionStorage._appMode == EnumAppMode.Teams: return EnumAppMode.Teams;
            case sessionStorage._appMode == EnumAppMode.NotTeams: return EnumAppMode.NotTeams;
            case sessionStorage._appMode == EnumAppMode.unset:
            default:
                return EnumAppMode.unset;
         }
    }
    public static setAppMode(value: EnumAppMode) {
       sessionStorage._appMode = value;
    }
}
